import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';

export const Accordion = withStyles({
  root: {
    border: 'none',
    boxShadow: 'none',
    '&:before': {
      display: 'none',
    },
    '&$expanded': {},
  },
  expanded: {},
})(MuiAccordion);

export const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'var(--background-color)',
    borderBottom: '1px solid var(--border-color)',
    color: ' var(--text-color)',
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '1em 0',
    },
  },
  expanded: {},
  expandIcon: {
    color: (props) => props.iconColor || 'var(--text-color)',
    fontSize: '1.4em',
  },
})(MuiAccordionSummary);

export const AccordionDetails = withStyles(() => ({
  root: {
    backgroundColor: ' var(--background-color)',
    color: ' var(--text-color)',
    padding: 0,
    display: 'flex',
    flexFlow: 'column nowrap',
  },
}))(MuiAccordionDetails);
